/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Router } from '@angular/router';
import { ProgressService } from 'src/refresh/service/progress-service';
import { TimerService } from 'src/refresh/service/timer-service';
import { GAData, Path } from '../constant/page-const';
import { InputData } from '../data/input-data';
import { IValidator } from './IValidator';

import { PageBaseComponent } from './page-base.component';

export abstract class FormBaseComponent extends PageBaseComponent {

     public validator:IValidator;
     
     constructor( router: Router,public timerService:TimerService, protected progress?:ProgressService ) {
          super(router,timerService);

          window.scrollTo(0, 0);
     } 

     protected setValidator(validator:IValidator) {
               this.validator = validator;
               ProgressService.validator = this.validator;
     }

     public onNextClick() : boolean{
     
          this.timerService.reset();
          
          if ( !this.validator || this.validator.validate() == true) {
                if ( this.progress ) this.progress.greyedOut(true);
                this.router.navigate([this.nextURL]);  
                window.scrollTo(0, 0);
                return true;
          }

          return false;
     }

     protected forwardNext(parentCnt:number):boolean {
           
      ////console.log("#"+parentCnt,this.timerService.isForwarding, InputData.moveNext,InputData.currentPageIdx);

             if ( this.timerService.isForwarding ) {
                  if ( InputData.moveNext > InputData.currentPageIdx ) {
                        this.router.navigate([this.nextURL]); 
                  }
                  else
                  if ( InputData.moveNext < InputData.currentPageIdx ) {
                        window.history.back();
                  }
                  else this.timerService.isForwarding = false;
                  return true;      
             }

             
             InputData.moveNext = 0;

/**
             if ( InputData.moveNext > 0 ) {

                  if ( InputData.moveNext > InputData.currentPageIdx ) {
                        InputData.recoverNext = true;

                        this.moveNext(InputData.currentPageIdx+1,parentCnt);
                        return true;
                  }
                  else {
                        if ( InputData.recoverNext ) {
                             InputData.recoverNext = false;
                             InputData.moveNext = 0;
                             return;
                        }

                        setTimeout( () => {
                              if ( InputData.recoverNext == false ) {
                                   InputData.moveNext = 0;
                              }
                              else InputData.recoverNext = false;
                                   
                         },1200);
      
                  }                   
             }

              */
 
             return false;
     }

     /**
     private moveNext(current:number,parentCnt:number) {

      switch(current) {
            case  2:  this.router.navigate(["/"+Path.BeforeYouBegin]); return;
            case  3:  this.router.navigate(["/"+Path.Setup1]); return;
            case  4:  this.router.navigate(["/"+Path.Setup2]); return;
            case  5:  this.router.navigate(["/"+Path.Setup3]); return;
            case  6:  this.router.navigate(["/"+Path.Setup4]); return;
            case  7:  this.router.navigate(["/"+Path.Setup5]); return;
            case  8:  this.router.navigate(["/"+Path.AboutTheChildMain]); return;
            case  9:  this.router.navigate(["/"+Path.AboutTheChildScreen2]); return;
            case 10:  this.router.navigate(["/"+Path.AboutTheParentsMain]); return;
            case 11:  this.router.navigate(["/"+Path.AboutTheParentsScreen1]); return;
            case 12:  this.router.navigate(["/"+Path.AboutTheParentsScreen2]); return;
            case 13:  this.router.navigate(["/"+Path.AboutTheParentsScreen3]); return;
            case 14:  this.router.navigate(["/"+Path.AboutTheParentsScreen4]); return;

            case 15:  this.router.navigate(["/"+Path.ContactInfoAndMailingAddress]); return;
            case 16:  this.router.navigate(["/"+Path.FinalReview]); return;
            case 17:  this.router.navigate(["/"+Path.Transition1]); return;
            case 18:  this.router.navigate(["/"+Path.BirthCertificate]); return;
            case 19:  this.router.navigate(["/"+Path.Transition2]); return;
            case 20:  this.router.navigate(["/"+Path.CCBMain]); return;
            case 21:  this.router.navigate(["/"+Path.SINMain]); return;
            case 22:  this.router.navigate(["/"+Path.ESRMain]); return;
      }

      if ( current >= 12 && current <= 14 ) {
           let  pCnt = (current-10);
           if ( pCnt <= parentCnt ) {
               this.router.navigate(["/"+Path.AboutTheParentsScreen+pCnt]); return;
           }
      }
      }

    */


     public onPreviousClick() {
            if ( this.progress ) this.progress.greyedOut(false);
            super.onPreviousClick();
     }

     public forward() {
     
          this.timerService.reset();
          this.router.navigate([this.nextURL]);  
          window.scrollTo(0, 0);
     }

      public  cancelApplication(inputData:InputData) {

             if ( inputData.subject.index <= 1 ) {
                  inputData.clear(); 
                  this.router.navigate([Path.Start]);  
             } 
             else {
                  this.progress.restore(inputData.removeChild());
                  this.router.navigate([Path.OrderSummary]);  
             }
             super.gtag(GAData.Button,GAData.cancel_app);
      }      
}
